<template>
  <Field class="form-field" :width="width">
    <label v-if="label" class="form-label" :for="id">
      {{ label }}
    </label>
    <Input
      ref="input"
      v-bind="$attrs"
      :class="{ error }"
      :id="id"
    />
    <div v-if="error" class="form-error">
      {{ error }}
    </div>
  </Field>
</template>

<script>
import Field from 'Web/Form/Fields/Field.vue';
import Input from 'Web/Form/Inputs/Input.vue';
import uid from '@/helpers/uid';

export default {
  inheritAttrs: false,
  components: {
    Field,
    Input,
  },
  props: {
    error: String,
    id: {
      type: String,
      default: uid,
    },
    label: String,
    width: String,
  },
  setup: Input.setup
}
</script>
